import React, { useState, useEffect, Fragment, useCallback } from "react";
import Button from "@material-ui/core/Button";
import lodashGet from "lodash.get";
import LoadingSpinner from "../LoadingSpinner";
import {
  getProjectNoMask,
  getNowReadyConfiguration,
  setNowReadyConfiguration,
  updateRegistrationTtl,
    getSuperUserInfo
} from "../../../../services/backendApi";
import "../../style.css";

export default ({ accountId, projectId }) => {
  const [project, setProject] = useState();
  const [brandConfiguration, setBrandConfiguration] = useState();
  const [registrationTtlHours, setRegistrationTtlHours] = useState("");
  const [saveInProgress, setSaveInProgress] = useState(false);
  const [configurationUpdated, setConfigurationUpdated] = useState(false);

  useEffect(() => {
    const getBrandConfiguration = async () => {
      try {
        const targetConfiguration = await getNowReadyConfiguration(projectId);
        if (targetConfiguration) {
          if(targetConfiguration.accountName){
            delete targetConfiguration.accountName
          }
          setBrandConfiguration(targetConfiguration);
          if (targetConfiguration.arrival
            && targetConfiguration.onTheWay
            && !targetConfiguration.confirmArrivalFields) {
            setBrandConfiguration((prevState) => {
              return {
                ...prevState,
                confirmArrivalFields: []
              }
            })
          }
        } else {
          alert("Something went really wrong getting the brand configuration");
        }
      } catch (err) {
        console.error(err);
        alert("Something went wrong getting the brand configuration");
      }
    };
    getBrandConfiguration();
  }, [projectId]);

  useEffect(() => {
    const getProjectData = async () => {
      try {
        const targetProject = await getProjectNoMask(projectId);
        setProject(targetProject);
        const registrationTtlSeconds = lodashGet(
          targetProject,
          "hello.registrationTtl"
        );
        if (registrationTtlSeconds) {
          const ttlHours = registrationTtlSeconds / 60 / 60;
          setRegistrationTtlHours(ttlHours);
        } else {
          setRegistrationTtlHours("");
        }
      } catch (err) {
        console.error(err);
        alert("Something went wrong getting the project details");
      }
    };
    getProjectData();
  }, [projectId]);

  const onSaveConfiguration = useCallback(async () => {
    if (saveInProgress) {
      return;
    }
    setSaveInProgress(true);
    try {
      const updateNowReadyPromise = setNowReadyConfiguration(
        brandConfiguration
      );
      if (registrationTtlHours) {
        const registrationTtlSeconds = registrationTtlHours * 60 * 60;
        if (
          lodashGet(project, "hello.registrationTtl") !== registrationTtlSeconds
        ) {
          await updateRegistrationTtl(projectId, registrationTtlSeconds);
        }
      }
      await updateNowReadyPromise;
      setConfigurationUpdated(false);
      alert("Configuration saved successfully");
    } catch (err) {
      console.error(err);
      alert("An unexpected error occurred. Failed to save brand configuration");
    }
    setSaveInProgress(false);
  }, [
    saveInProgress,
    projectId,
    accountId,
    registrationTtlHours,
    brandConfiguration,
  ]);

  const onChangeRegistrationTtl = (event) => {
    const newValue = event.target.value;
    if ((newValue !== "" && newValue < 1) || newValue > 168) {
      return;
    }
    setRegistrationTtlHours(newValue);
    setConfigurationUpdated(true);
  };

  const onChangeOrderFlow = (targetConfiguration) => {
    if (targetConfiguration === "both") {
      setBrandConfiguration((prevState) => ({
        ...prevState,
        onTheWay: true,
        arrival: true,
        confirmArrivalFields: [],
      }));
    } else {
      setBrandConfiguration((prevState) => {
        const newState = {
          ...prevState,
          onTheWay: false,
          arrival: true,
        }
        delete newState.confirmArrivalFields;
        return newState;
      });
    }
    setConfigurationUpdated(true);
  };

  return (
    <div>
      <h3>{`Configure Super User Settings For Now Ready Screens - ${project ? project.name : projectId}`}</h3>
      {!project || !brandConfiguration ? (
        <LoadingSpinner />
      ) : (
        <Fragment>
          <div className="config-section registration-ttl-and-order-flow">
            <div className="registration-ttl">
              <h3>
                Add how long the user token is active for in hours (Default 24
                hours)
              </h3>
              <div className="registration-ttl-input-and-message">
                <input
                  type="number"
                  placeholder="Registration Time To Live"
                  value={registrationTtlHours}
                  onChange={onChangeRegistrationTtl}
                />
                <p>Maximum is 7 days (168 hours)</p>
              </div>
            </div>
            <div className="order-flow-config">
              <div>
                <input
                  type="radio"
                  id="both"
                  name="orderFlow"
                  value="Both"
                  onClick={() => onChangeOrderFlow("both")}
                  defaultChecked={
                    brandConfiguration.onTheWay && brandConfiguration.arrival
                  }
                />
                <label htmlFor="both">On my way & I'm here</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="imHere"
                  name="orderFlow"
                  value="ImHere"
                  onClick={() => onChangeOrderFlow("imHere")}
                  defaultChecked={
                    brandConfiguration.arrival && !brandConfiguration.onTheWay
                  }
                />
                <label htmlFor="imHere">I'm here</label>
              </div>
            </div>
          </div>
          <div className="bottom-panel">
            <div className="save-nowready-config-button">
              <Button
                color="primary"
                variant="contained"
                onClick={() =>
                  onSaveConfiguration()
                }
              >
                Save
              </Button>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};
